<template>
  
<div id="search_page" class="search_popup">
	<a id="close_btn" @click=" $emit('closesearch'); "><i class="material-icons dp48">close</i></a>  
	<div class="dark_bg"></div>
	<div class="content">
    <div id="background_close"  @click="close_search()"></div>

	<div class="centered_md">
		<div class="row">
			
			<form class="col-md-12" id="search_area" @submit.prevent="do_search()" method="get">
				<input ref="search_inp"  id="search_text" type="text" name="q" placeholder="חיפוש" autocomplete="off" v-model="q_val" @keyup="do_search()">
				<input type="submit" style="display:none;">
			</form>

		</div> 
			<div id="search_results">
		<div class="row">
				<div v-if="no_results">
          לא נמצאו תוצאות, נסה חיפוש אחר
        </div>

                    <div v-for="item in items" class="col-md-3 col-xs-3" :key="item.id" :data-blat="item.id" >
                     
                        <itemTpl :item="item" />
                    </div>


 

                    </div>

                        <div class="next_page">&nbsp;</div>
				
			</div>
		</div>
    </div>
</div>

</template>

<script>
import itemTpl from './item_tpl.vue'


export default {
  components: { itemTpl },
    props: ["search_promote"],
  data() {
    return {
      no_results: false,
        xhrsearch: null,
        q_val: '',
        page: 1,
      items: []
    };
  },
  methods: {
      close_search(){ this.reset();  this.$emit('closesearch'); },
      reset(){ 
        this.q_val = '';
        this.page = 1;
        this.items = [];
        var self = this;
        setTimeout(function(){ self.$refs["search_inp"].focus(); }, 100);

      },
      do_search(){
            this.no_results = false;

            var self = this;
            if (this.q_val.length > 0)
            {
                //if (this.xhrsearch != null) this.xhrsearch.abort();
                this.$http.post(window.api_url + 'search/results', { 
                    limit:20, 
                    q: this.q_val, 
                    page: this.page, 
                    api_user_token: localStorage.getItem('user_token')
                },{
            
                    // use before callback
                    before(request) {

                    // abort previous request, if exists
                    if (this.xhrsearch) {
                        this.xhrsearch.abort();
                    }

                    // set previous request on Vue instance
                    this.xhrsearch = request;
                    },

                }).then(function(data){
                    self.items = data.data.data.items;

                    if (self.items.length == 0)  this.no_results = true;

                });
            }
            else
            {
                this.items = [];
            }

      }
  },
  watch:{
    $route (){
     
        this.close_search();
    }
  }

}
</script>





